export const PROMOTION_100_VOUCHER = {
  TITLE: `한 달 100원 프로모션 혜택 적용 안내`,
  DESCRIPTIONS: `월별 자동결제 가격 안내`,
  NOTICES: [
    `100원 결제 전 이용권 변경, 환불 또는 자동결제 해지 시, 100원 혜택이 제공되지 않습니다.`,
    `혜택없이 이용권을 구매하면, 최초 인증 한 달 100원 프로모션은 재적용되지 않습니다.`,
    `‘유료상품이용약관’에 따라 구독을 해지하거나 이용권을 변경하실 수 있습니다.`,
  ],
}

export const PROMOTION_100_CANCEL_VOUCHER = {
  TITLE:
    '지금 이용권을 변경하시면,\n한 달 100원 프로모션을 이용할 수 없습니다.',
  DESCRIPTION: `고객님은 현재 한 달 100원 프로모션 혜택 대상자입니다.\n이용권 변경하시면, 혜택을 받을 수 없습니다.\n\n이용권을 변경하시겠습니까?`,
  CONFIRM_TEXT: '이용권 변경',
}

export const PROMOTION_100_CANCEL_SUBSCRIPTION_TICKET = {
  TITLE: `지금 자동결제를 해지하시면,\n한 달 100원 프로모션을 이용할 수 없습니다.`,
  DESCRIPTION: `고객님은 현재 한 달 100원 프로모션 혜택 대상자입니다.\n이용권 자동결제를 해지하시면, 혜택을 받을 수 없습니다.\n\n자동 결제를 해지 하시겠습니까?`,
  CONFIRM_TEXT: '자동결제 해지',
}

export const CONSENT_STATUS = {
  AGREED: 'agreed',
  YET: 'yet',
  DISAGREED: 'disagreed',
}

export const VOUCHER_TRANSFER = {
  TITLE: '이용권 전환 대상이 아닙니다.',
  DESCRIPTION: '이용권 전환대상 ID로 로그인하시고\n다시한번 시도해주세요.',
  CONFIRM_TEXT: '확인',
}

export const IOS_VOUCHER_TRANSFER = {
  TITLE: 'iOS 환경에서 구매한 이용권입니다.',
  DESCRIPTION: '아이폰 또는 아이패드의 앱에서\n다시한번 시도해주세요.',
  CONFIRM_TEXT: '확인',
}
